import { connect } from 'react-redux';

import container from 'src/ServiceContainer';
import { ParameterTogglesConfig } from 'src/pages/Allocation/ParameterToggles/ParameterToggles.types';
import type { ParameterTogglesOwnProps } from 'configuration-schemas/ownProps';
import { allocationParameterTogglesLens, scopeLens } from 'src/services/lenses/lenses';
import {
  requestParameterTogglesConfig,
  receiveParameterTogglesConfig,
} from 'src/pages/Allocation/ParameterToggles/ParemeterToggles.slice';
import { ASSORTMENT } from 'src/utils/Domain/Constants';
import ParameterToggles from 'src/pages/Allocation/ParameterToggles/ParameterToggles';
import { makeScopeSensitive } from 'src/components/higherOrder/ScopeSensitive';
import { AppState, AppThunkDispatch } from 'src/store';
import { isNil, isEmpty } from 'lodash';
import { getFloorsetData, getSelectedFloorset } from 'src/components/ConfigurableGrid/ConfigurableGrid.selectors';
import { fetchFloorsetData } from 'src/components/ConfigurableGrid/ConfigurableGrid.slice';
import { updateAssortmentPlan } from 'src/pages/AssortmentBuild/StyleEdit/StyleEdit.actions';
import { FabType, getfabProps, withFab } from 'src/components/higherOrder/withFab';
import { updateTopMemberSelection } from 'src/components/Subheader/Subheader.slice';
import { getTopMemberDropdownProps } from 'src/components/Subheader/Subheader.selectors';

function mapStateToProps(state: AppState, ownProps: ParameterTogglesOwnProps) {
  const { fabType = FabType.none } = ownProps;
  const fabProps = getfabProps(state, fabType);

  const scope = scopeLens.get(state);
  const parameterToggles = allocationParameterTogglesLens.get(state);
  const { isConfigLoading, isDataLoading, viewDefn /* data */ } = parameterToggles;

  let hasTopMemberDropdown = false;
  if (!isNil(viewDefn)) {
    hasTopMemberDropdown = !isNil(viewDefn.subheaderDropdowns?.topMember);
  }
  const topMemberDropdown = getFloorsetData(state);
  const loadingDropdown = hasTopMemberDropdown && isEmpty(topMemberDropdown);
  const topMemberDropdownProps = getTopMemberDropdownProps(state, {
    topMember: viewDefn?.subheaderDropdowns?.topMember,
  });
  let selectedTopMember: string | null = null;
  if (hasTopMemberDropdown && !loadingDropdown) {
    selectedTopMember = getSelectedFloorset(state) ?? topMemberDropdown[0].id;
  }

  return {
    isLoading: isConfigLoading || isDataLoading || loadingDropdown,
    config: viewDefn,
    scopeParams: {
      productMember: scope.productMember || '',
      locationMember: scope.locationMember || '',
    },
    topMemberDropdownProps,
    selectedTopMember,
    fab: fabProps,
  };
}

function dispatchToProps(dispatch: AppThunkDispatch, ownProps: ParameterTogglesOwnProps) {
  return {
    async onShowView() {
      dispatch(requestParameterTogglesConfig());
      const config = await container.tenantConfigClient.getTenantViewDefn<ParameterTogglesConfig>({
        defnId: ownProps.defns.view[0],
        appName: ASSORTMENT,
      });
      if (config.subheaderDropdowns?.topMember) {
        dispatch(fetchFloorsetData(config.subheaderDropdowns.topMember.dataApi));
      }
      dispatch(receiveParameterTogglesConfig(config));
    },
    onUpdateTopMember(selection: string) {
      dispatch(updateTopMemberSelection(selection));
    },
    onSubmitPlan(defnId: string, data: Record<string, boolean | string> | null) {
      return dispatch(updateAssortmentPlan('Worklist', { defnId, data }));
    },
  };
}
export interface ParameterTogglesDispatchProps extends ReturnType<typeof dispatchToProps> {}
export interface ParameterTogglesValueProps extends ReturnType<typeof mapStateToProps> {}

export default connect(mapStateToProps, dispatchToProps)(makeScopeSensitive(withFab(ParameterToggles)));
